/**
 * Special @all mention: inserting "@all" notifies every user (handled by the backend).
 * Shaped like a user object so the existing suggestion lists can render it as-is.
 */
export const MENTION_ALL_USERNAME = 'all';

// Group icon used as the @all avatar, styled like the letter avatars
// (bg-primary/10 circle, text-primary icon; --primary is #1447e6 in both themes)
const MENTION_ALL_ICON =
    'data:image/svg+xml;utf8,' +
    encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">' +
        '<circle cx="16" cy="16" r="16" fill="#1447e6" fill-opacity="0.1"/>' +
        '<g transform="translate(9 9) scale(0.5833)" fill="none" stroke="#1447e6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>' +
        '<path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>' +
        '</g></svg>'
    );

export const MENTION_ALL_SUGGESTION = {
    id: '__mention_all__',
    username: MENTION_ALL_USERNAME,
    first_name: 'Notify',
    last_name: 'everyone',
    email: '',
    picture: MENTION_ALL_ICON,
};

/** * Filter users for @mention suggestions using prefix matching on first_name.
 * Only shows users whose first_name starts with the query.
 * The @all option is shown first when the query is a prefix of "all".
 *
 * @param {Array} users - Array of user objects with username, first_name, last_name
 * @param {string} query - The search query (text after @)
 * @param {number} limit - Maximum number of results to return (default: 10)
 * @returns {Array} Filtered array of users matching the prefix
 */
export const filterMentionSuggestions = (users, query, limit = 10) => {
    const q = query.toLowerCase();

    const matchedUsers = users.filter(user =>
        user.first_name?.toLowerCase().startsWith(q)
    );

    if (MENTION_ALL_USERNAME.startsWith(q)) {
        return [MENTION_ALL_SUGGESTION, ...matchedUsers].slice(0, limit);
    }

    return matchedUsers.slice(0, limit);
};
